import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import MicrosoftExcelGreenIcon from "../../../../../assets/icons/microsoftExcelGreen";
import Spinner from "../../../../../components/common/Spinner";
import { useQuery, useMutation } from "react-query";
import axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import "./ImportsHistory.css";
import dayjs from "dayjs";
import { MdError } from "react-icons/md";
import { Tooltip } from "antd";

/**
 * ImportsHistory component
 * @param {function} setShowHistory - Function to set the visibility of the history
 */

const ImportsHistory = ({ setShowHistory }) => {
  const fetchSuppliers = async () => {
    const { data } = await axios.get("/api/v1/supplier_imports");
    return data;
  };
  const historyContainerRef = React.useRef();

  const downloadSupplierImport = (url) => {
    window.open(url);
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (
        historyContainerRef.current &&
        !historyContainerRef.current.contains(event.target)
      ) {
        setShowHistory(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const mutation = useMutation(downloadSupplierImport, {
    onSuccess: () => {
      antdAsyncMessageSuccess();
    },
    onError: () => {
      antdAsyncMessageError();
    },
  });
  const {
    data: suppliersData,
    isLoading,
    error,
  } = useQuery("suppliers", fetchSuppliers);

  if (isLoading) return <p>Loading...</p>;
  if (error) return "An error has occurred: " + error.message;
  if (suppliersData?.data?.length === 0) return <p>No data.</p>;

  return (
    <div className="historyContainer" ref={historyContainerRef}>
      <div className="header">
        <p className="headerText">Imports history</p>
        <div
          className="cursor-pointer"
          onClick={() => setShowHistory((prev) => !prev)}
        >
          <AiOutlineClose />
        </div>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        "An error has occurred: " + error.message
      ) : suppliersData?.data?.length === 0 ? (
        <p>No data.</p>
      ) : (
        suppliersData.data.map((supplierImport) => (
          <div
            key={supplierImport.id}
            onClick={() => mutation.mutate(supplierImport.asset.url)}
            className="supplierImport"
          >
            <div className="supplierImportDetails">
              <div>
                <div className="d-flex justify-content-center align-items-center flex-row">
                  {supplierImport?.error ? (
                    <>
                      <Tooltip
                        placement="top"
                        title={
                          supplierImport?.error ||
                          "Suppliers upload failed due to errors"
                        }
                      >
                        <MdError className="mr-1" color="#D60D00" />
                      </Tooltip>
                    </>
                  ) : null}
                  <p className="supplierImportDate">
                    {dayjs(supplierImport?.created_at).format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </p>
                </div>

                <p className="supplierImportUser">
                  {supplierImport?.user_full_name || "-"}
                </p>
              </div>
              <div>
                <MicrosoftExcelGreenIcon />
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ImportsHistory;
